'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

define(['app', '$window'], function (app, window) {
  var purchaseScript = function purchaseScript() {
    var component = {};

    var _updateBasket = function _updateBasket() {
      component.update(window.dataLayer[0].basketProducts);
    };

    var _update = function _update(dataItems) {
      var ShoeSizeShoppingCart = { "shopID": "14617462", "purchases": [] };
      window.ShoeSizeShoppingCart = ShoeSizeShoppingCart;

      dataItems.forEach(function (arrayItem) {
        var item = {
          "shoeID": arrayItem.childMasterProductId || arrayItem.masterId,
          "size": arrayItem.size,
          "scale": "uk", // downscale
          "quantity": arrayItem.quantity,
          "price": arrayItem.price
        };
        ShoeSizeShoppingCart.purchases.push(item);
      });
      component.runScript();
    };

    var postData = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("https://shoesize.me/api/config/integrity", { method: 'GET' });

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.json());

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function postData() {
        return _ref.apply(this, arguments);
      };
    }();

    // Loop throught the items in the cart
    // and push their properties into the purchases object

    // Do not modify
    var _runScript = function _runScript() {

      postData().then(function (integrity) {
        (function () {
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.crossOrigin = 'anonymous';
          script.integrity = integrity.cart_integrity;
          script.src = 'https://shoesize.me/plugin/cart.js?' + 'shopid=' + encodeURIComponent(ShoeSizeShoppingCart.shopID) + '&sid=' + Math.round(new Date().getTime() / 1000);
          (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        })();
      });
    };

    component.updateBasket = _updateBasket;
    component.update = _update;
    component.runScript = _runScript;

    return component;
  };
  return purchaseScript;
});
//# sourceMappingURL=purchaseScript.js.map
